import loadable from '@loadable/component'

export default [
  {
    path: '/MidYearAnchorCompetition2026',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MidYearAnchorCompetition2026" */ '~/pages/ToyBricks/CustomComponents/MidYearAnchorCompetition2026/index'
        )
    ),
  },
  {
    path: '/MidYearAnchorCompetition2026/Rules',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MidYearAnchorCompetition2026-Rules" */ '~/pages/ToyBricks/CustomComponents/MidYearAnchorCompetition2026/pages/Rules/index'
        )
    ),
  },
  {
    path: '/MidYearAnchorCompetition2026/notice',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MidYearAnchorCompetition2026-AdvancementAnnouncementModal" */ '~/pages/ToyBricks/CustomComponents/MidYearAnchorCompetition2026/pages/AdvancementAnnouncementModal/index'
        )
    ),
  },
  {
    path: '/MidYearAnchorCompetition2026/revival',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MidYearAnchorCompetition2026-PromotionModal" */ '~/pages/ToyBricks/CustomComponents/MidYearAnchorCompetition2026/pages/PromotionModal/index'
        )
    ),
  },
  {
    path: '/MidYearAnchorCompetition2026/banner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MidYearAnchorCompetition2026-GiftBanner" */ '~/pages/ToyBricks/CustomComponents/MidYearAnchorCompetition2026/pages/GiftBanner/index'
        )
    ),
  },
]
